const Line = () => {
	return (
		<hr className="w-full my-4"/>
	)
}
export default Line;